"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorEnum = void 0;
var ColorEnum;
(function (ColorEnum) {
    ColorEnum["Blue"] = "blue";
    ColorEnum["BlueLight"] = "blueLight";
    ColorEnum["BlueDark"] = "blueDark";
    ColorEnum["Purple"] = "purple";
    ColorEnum["PurpleLight"] = "purpleLight";
    ColorEnum["PurpleDark"] = "purpleDark";
    ColorEnum["Green"] = "green";
    ColorEnum["GreenLight"] = "greenLight";
    ColorEnum["GreenDark"] = "greenDark";
    ColorEnum["Primary"] = "primary";
    ColorEnum["PrimaryLight"] = "primaryLight";
    ColorEnum["PrimaryDark"] = "primaryDark";
    ColorEnum["Secondary"] = "secondary";
    ColorEnum["SecondaryLight"] = "secondaryLight";
    ColorEnum["SecondaryDark"] = "secondaryDark";
    ColorEnum["Gray"] = "gray";
    ColorEnum["GrayLight"] = "grayLight";
    ColorEnum["GrayDark"] = "grayDark";
    ColorEnum["Orange"] = "orange";
    ColorEnum["OrangeLight"] = "orangeLight";
    ColorEnum["OrangeDark"] = "orangeDark";
    ColorEnum["Red"] = "red";
    ColorEnum["RedLight"] = "redLight";
    ColorEnum["RedDark"] = "redDark";
    ColorEnum["Pink"] = "pink";
    ColorEnum["PinkLight"] = "pinkLight";
    ColorEnum["PinkDark"] = "pinkDark";
    ColorEnum["Brown"] = "brown";
    ColorEnum["BrownLight"] = "brownLight";
    ColorEnum["BrownDark"] = "brownDark";
    ColorEnum["Yellow"] = "yellow";
    ColorEnum["YellowLight"] = "yellowLight";
    ColorEnum["YellowDark"] = "yellowDark";
})(ColorEnum = exports.ColorEnum || (exports.ColorEnum = {}));
//# sourceMappingURL=color-enum.js.map